import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useCalendarStore, useForm } from "../../../hooks";
import { toLocalISOString } from "../../../helpers";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
} from "../../ui";
import { scheduleStatuses } from "../../data";
import { useFormMessages } from "../../hooks";

// const initialFormData = {
//   notes: "2+2=4",
//   start: "",
//   end: "",
//   title: "Cirugia test 2",
//   stateId: "c17acc24-5f9f-4ebd-9925-a4477e77774c",
//   patientId: "",
// };

const initialFormData = {
  notes: "",
  start: "",
  end: "",
  title: "",
  state: "",
};

const formValidations = {
  notes: [(value) => value.length > 0, "Las notas no pueden ser vacias"],
  start: [(value) => value.length > 0, "Selecciona una fecha inicial"],
  end: [(value) => value.length > 0, "Selecciona una fecha final"],
  title: [(value) => value.length > 0, "El titulo no puede ser vacio"],
  state: [(value) => value.length > 0, "Selecciona un estado"],
};

export const ModalAddScheduleEvent = ({ event, addevent, setAddEvent }) => {
  // Datos de hooks ----------------------------------------//
  const {
    //Props
    message,
    isLoading,

    //Methods
    startRegisterScheduleEvent,
  } = useCalendarStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  const { notes, start, end, title, state } = formState;

  const { notesValid, startValid, endValid, titleValid, stateValid } =
    formValidation;

  // Funciones ---------------------------------------------//
  const onAddScheduleEvent = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startRegisterScheduleEvent(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (event) {
      setFormData((prev) => ({
        ...prev,
        start: toLocalISOString(event.start),
        end: toLocalISOString(event.end),
      }));
    }
  }, [event]);

  useEffect(() => {
    if (!addevent) {
      setValidateForm(false);
      setFormSubmitted(false);
      onResetForm();
    }
  }, [addevent]);

  useEffect(() => {
    if (showSuccessMessage) {
      setAddEvent(false);
    }
  }, [showSuccessMessage]);

  return (
    <Modal
      show={addevent}
      onHide={() => {
        setAddEvent(false);
      }}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Agregar evento
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <InputForm
                label={"Titulo"}
                type={"text"}
                placeholder={"Titulo"}
                validation={titleValid}
                submit={validateForm}
                name={"title"}
                value={title}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Link de conexión / Ubicación"}
                type={"text"}
                placeholder={"Link de conexión / Ubicación"}
                validation={notesValid}
                submit={validateForm}
                name={"notes"}
                value={notes}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <SelectForm
                label={`Estado`}
                options={scheduleStatuses}
                labelKey={"name"}
                validation={stateValid}
                submit={validateForm}
                name={`state`}
                value={state}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Hora inicio"}
                type={"datetime-local"}
                validation={startValid}
                submit={validateForm}
                name={"start"}
                value={start}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Hora final"}
                type={"datetime-local"}
                validation={endValid}
                submit={validateForm}
                name={"end"}
                value={end}
                onInputChange={onInputChange}
              />
            </div>
          </>
          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          type={"button"}
          onClick={() => setAddEvent(false)}
          disabled={isLoading}
        >
          Cancelar
        </CancelButton>
        <MainButton
          type={"button"}
          onClick={() => onAddScheduleEvent()}
          disabled={isLoading}
        >
          Agregar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
